<template>
  <v-layout row wrap>
    <v-flex xs12 md8 v-if="!getProfileHaveClient">
      <v-card>
        <v-card-title>
          <span class="headline">Депозитарий обеспечивает Юридическую Значимость Вашим документам.</span>
        </v-card-title>
        <v-card-text>
          Для загрузки документов, необходимо определить Юридическое лицо которое Вы представляете.
          Регистрируйтесь и загрузите свои первые документы.
        </v-card-text>
        <v-card-actions>
          <v-btn to="/register">Регистрация</v-btn>
          <!-- <v-btn to="/profile">Продолжить регистрацию</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-flex>
    <v-flex xs12 md8 v-if="getProfileHaveClient">
    <v-card>
      <v-toolbar light prominent flat >
        <v-flex>
          <v-layout row align-center>
            <v-icon light v-html="cxt.getTitleIcon()"></v-icon>
            <v-toolbar-title v-if="!getIsMobile">{{cxt.getTitle()}}</v-toolbar-title>
          </v-layout>
          <v-flex v-if="!getIsMobile" pl-3 class="caption" v-html="formatCountTitle"></v-flex>
          <v-flex v-if="getIsMobile" class="caption" v-html="formatCountTitle"></v-flex>
        </v-flex>
        <v-flex sm4 xs6>
          <v-chips-field 
            emptyChip="Метки"
            solo flat
            @remove="removeInn" 
            @click="selectInn" 
            :items="chipsItems" 
            :chipSize="getIsMobile ? 12 : 25" > 
          </v-chips-field>
        </v-flex>
            <v-flex v-show="cxt.isFilterMode()" sm4 xs4 >
              <v-text-field
                autofocus
                label="Фильтр"
                v-show="cxt.isFilterMode()"
                :value="cxt.filterString"
                v-on:input="onChangeFilter"
                solo flat
              ></v-text-field>
            </v-flex>
            <span v-show="!cxt.isSelectMode()">
              <span v-show="!cxt.isFilterMode()">
                <v-btn  icon @click="addFile()">
                  <v-icon>add</v-icon>
                </v-btn>
              </span>
            </span>
          <v-ops-btn :cxt="cxt" flat></v-ops-btn>
      </v-toolbar>
      <v-progress-linear style="margin-top: 0; margin-bottom: 0" height=2 :active="getItemSet.isProcessing()" :indeterminate="true"></v-progress-linear>
      <v-card-scroll ref="cardScroll" v-on:nextPage="nextPage">
      <v-list two-line dense>
        <v-list-tile>
          <v-list-tile-content>
          <v-actions-btn :caption="folderActionsCaption" :actions="folderActions"></v-actions-btn>
          </v-list-tile-content>
        </v-list-tile>
      <v-list-tile avatar v-for="item in depoFolders" :key="item.uid" @click="!cxt.isSelectMode() ? setFolder(item.fileName) : cxt.select(item.uid)">
            <v-list-tile-avatar>
              <v-icon>folder</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.docName }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <span>
                <v-btn v-show="!cxt.isSelectMode()" icon @click.prevent="openFolder(item.uid)">
                  <v-icon color="grey lighten-1" >info_outline</v-icon>
                </v-btn>
                <v-icon v-show="cxt.check(item.uid)">check_box</v-icon>
                <v-icon v-show="cxt.uncheck(item.uid)">check_box_outline_blank</v-icon>
              </span>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider inset></v-divider>
        <template v-for="item in this.filteredItems">
          <v-subheader v-if="item.header" v-text="item.header"></v-subheader>
          <v-divider v-else-if="item.divider" v-bind:inset="item.inset"></v-divider>
          <v-list-tile v-else v-bind:key="item.uid" @click="!cxt.isSelectMode() ? openFile(item.uid) : cxt.select(item.uid)">
            <v-list-tile-avatar tile>
              <!-- <v-component :is="createComp(getPreview(item))" />  -->
              <v-component :is = "createPreview(item)" />
            </v-list-tile-avatar>
             <v-list-tile-content>
              <v-list-tile-title><b>{{item.docName}}</b></v-list-tile-title>
              <v-list-tile-sub-title><a @click.stop="!cxt.isSelectMode() ? open(item) : cxt.select(item.uid)">{{item.uid}}</a></v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <span>
                <v-icon v-show="cxt.check(item.uid)">check_box</v-icon>
                <v-icon v-show="cxt.uncheck(item.uid)">check_box_outline_blank</v-icon>
              </span>
              <v-list-tile-action-text v-show="!cxt.isSelectMode()"><p></p></v-list-tile-action-text>
              <v-list-tile-action-text>{{formats.blank(item.uploaded, formats.formatDate)}}</v-list-tile-action-text>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </v-card-scroll>
    </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import apimix from '../common/apimix'
  import vDocFolder from './DocFolder.vue'
  import vFolderSelector from './FolderSelector.vue'
  import dialogs from '../common/dialogs'
  import classes from '../../api/classes'
  import vOpsBtn from '../common/OpsBtn'
  import vActionsBtn from '../common/ActionsBtn'
  import vChipsField from '../common/ChipsField.vue'
  import vCardScroll from '../common/CardScroll'
  import depo from '.'
  import client from '../client'

  export default {
    name: 'doc-list',
    components: {vOpsBtn, vActionsBtn, vChipsField, vCardScroll},
    mixins: [apimix],
    props: {
    },
    data: () => ({
      timer: '',
      chipsItems: [],
      cxt: null,
      order: 'BY_UPLOADED'
    }),
    beforeDestroy () {
      window.clearInterval(this.timer)
    },
    created () {
      var cxt = new classes.MultiSelectContext(() => {
        return this.filteredItems.map(item => item.uid)
      })
      cxt.actions.push(new classes.FilterAction(cxt))
      cxt.actions.push(new classes.FilterEndAction(cxt))
      cxt.actions.push(new classes.Action(this, 'Упорядочить по дате', () => this.order !== 'BY_UPLOADED',
        () => {
          this.order = 'BY_UPLOADED'
          this.onChangeSort()
        }))
      cxt.actions.push(new classes.Action(this, 'Упорядочить по названию', () => this.order !== 'BY_NAME',
        () => {
          this.order = 'BY_NAME'
          this.onChangeSort()
        }))
      cxt.actions.push(new classes.Action(this, 'Сегодня',
        () => this.getItemSet.getFilter().scope !== this.getDepoConstant.ACTIVE_SCOPE,
        () => this.onChangeScope(this.getDepoConstant.ACTIVE_SCOPE))
      )
      cxt.actions.push(new classes.Action(this, 'Все', null,
        () => {
          this.cxt.showAll()
          this.onChangeScope(this.getDepoConstant.ALL_SCOPE)
        }))
      cxt.actions.push({divider: true})
      cxt.actions.push(new classes.SelectAction(cxt))
      cxt.actions.push({divider: true})
      cxt.actions.push(new classes.Action(this, 'Новый документ', null,
        () => this.addFile()))
      cxt.actions.push(new classes.Action(this, 'Новая папка', null,
        () => this.addFolder()))

      cxt.selectActions.push(new classes.FilterAction(cxt))
      cxt.selectActions.push(new classes.FilterEndAction(cxt))
      cxt.selectActions.push(new classes.Action(this, 'Удалить папку', null,
        () => this.deleteFolders(cxt.selectedIds)))
      cxt.selectActions.push(new classes.Action(this, 'Копировать свойства', null,
        () => this.copyProps(cxt.selectedIds)))
      cxt.selectActions.push(new classes.Action(this, 'Копировать ссылку', null,
        () => this.copyLinks(cxt.selectedIds)))
      cxt.selectActions.push(new classes.Action(this, 'Поделиться', null,
        () => this.sendProps(cxt.selectedIds)))
      cxt.selectActions.push(new classes.Action(this, 'Скачать', null,
        () => this.downloadFiles(cxt.selectedIds)))
      cxt.selectActions.push(new classes.Action(this, 'Переместить', null,
        () => this.updateFolder(cxt.selectedIds)))
      cxt.selectActions.push(new classes.Action(this, 'Пометить', null,
        () => this.updateTags(cxt.selectedIds)))
      cxt.selectActions.push({divider: true})
      cxt.selectActions.push(new classes.SelectAllAction(cxt))
      cxt.selectActions.push({divider: true})
      cxt.selectActions.push(new classes.SelectEndAction(cxt))

      cxt.title = 'Депозитарий'
      cxt.titleIcon = 'storage'
      cxt.selectTitle = 'Выбор файлов'
      cxt.filterMode = true

      this.cxt = cxt
    },
    mounted () {
      this.$store.dispatch('fetchDepoFolders')
      this.fetchData()
    },
    watch: {
    // в случае изменения маршрута запрашиваем данные вновь
      '$route' () {
        this.fetchData()
      },
      getProfileHaveClient: function (newVal, oldVal) { // watch it
        if (newVal && !oldVal) {
          this.fetchData()
        }
      }
    },
    computed: {
      ...mapGetters({
        getIsMobile: 'getIsMobile',
        profile: 'getProfile',
        depoFolders: 'getDepoFilteredFolders',
        getItemSet: 'getDepoFileSet',
        depoPathFolders: 'getDepoPathFolders',
        getDepoConstant: 'getDepoConstant',
        getProfileHaveClient: 'getProfileHaveClient',
        getDepoPathByFolder: 'getDepoPathByFolder',
        getDepoCurrentPath: 'getDepoCurrentPath',
        renderDepoFileSignMessage: 'renderDepoFileSignMessage',
        getDepoFilesUrl: 'getDepoFilesUrl',
        getDepoUrl: 'getDepoUrl'

      }),
      title () {
        return
      },
      items () {
        return this.getItemSet.getItems()
      },
      orderedItems () {
        return this.items
      },
      foldedItems () {
        let path = this.getDepoCurrentPath
        return this.orderedItems.filter(i => i.path === path)
      },
      tagedItems () {
        const getSearchString = (item) => {
          return ''.concat(item.tags)
        }
        var result = this.foldedItems
        let refs = this.getRefs(this.getTags())
        if (Array.isArray(refs)) {
          refs.forEach(tag => {
            var t = tag.toUpperCase()
            result = result.filter(item => getSearchString(item).toUpperCase().includes(t))
          })
        }
        return result
      },
      filteredItems () {
        const getSearchString = (item) => {
          return ''
            .concat(
              item.docName,
              item.fileName,
              item.tags,
              formats.formatDate(item.uploaded))
        }
        // var result = this.orderedItems
        var result = this.tagedItems

        if ((!this.cxt.isFilterMode()) || (this.cxt.filterString === null)) {
          return result
        }
        let terms = formats.parseSearchTerms(this.cxt.filterString)
        if (terms.length < 1) {
          return result
        }
        return result.filter(item => {
          let searchStr = getSearchString(item).toLowerCase()
          return terms.every(t => (searchStr.includes(t)))
        })
      },
      formatCountTitle () {
        var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано '
        if (this.cxt.isSelectMode()) {
          return this.getItemSet.getTotal() > 0 ? label + this.cxt.selectedCount() + ' из ' + this.getItemSet.getTotal() + '' : ''
        } else {
          return this.getItemSet.getTotal() > 0 ? label + this.filteredItems.length + ' из ' + this.getItemSet.getTotal() + '' : ''
        }
      },
      folderActionsCaption () {
        if (this.folderActions.length > 0) {
          return this.folderActions[0].title
        }
        return null
      },
      folderActions () {
        return this.depoPathFolders.sort((a, b) => b.path.length - a.path.length).map(item => new classes.Action(this, item.docName, null, () => this.setFolder(item.fileName)))
      }
    },
    methods: {
      changeFilterContext (ops, force) {
        this.$store.commit('setDepoFileSetFilterContext', Object.assign({}, this.getItemSet.getFilter(), ops))
        var self = this
        setTimeout(() => {
          self.$store.dispatch('fetchDepoFileSet', force)
          self.scrollToActive()
        }, 500)
      },
      onChangeFilter (e) {
        this.cxt.filterString = e
        if ((this.getProfileHaveClient)) {
          let search = formats.stringifySearchTerms(formats.parseSearchTerms(this.cxt.filterString))
          if (formats.compareString(search, this.getItemSet.getFilter().search) !== 0) {
            this.changeFilterContext({search: search}, true)
          }
        }
      },
      getSortString () {
        switch (this.order) {
          case 'BY_NAME':
            return 'docName'
          case 'BY_UPLOADED':
            return 'uploaded,desc'
          default:
            return ''
        }
      },
      onChangeSort (v) {
        this.$store.commit('setDepoFileSetSort', this.getSortString())
        this.changeFilterContext(null, true)
      },
      onChangeScope (v) {
        this.changeFilterContext({scope: v}, true)
      },
      fetchData (force) {
        if (this.getProfileHaveClient) {
          this.$store.commit('setDepoFileSetSort', this.getSortString())
          var folderName = this.$route.params.folderName ? this.$route.params.folderName : 'root'
          let path = this.getDepoPathByFolder(folderName)
          this.changeFilterContext({search: this.cxt.filterString, path: path, tags: this.getTags()}, force)
          this.fillRefChips(this.getRefs(this.getTags()))
        }
      },
      nextPage () {
        this.$store.commit('nextDepoFileSet')
        this.$store.dispatch('fetchDepoFileSet')
      },
      scrollToActive () {
        this.$nextTick(() => {
          this.$refs.cardScroll.scrollToListActive()
        })
      },
      newFile (id) {
        depo.newFile(this.getDepoCurrentPath, null, id, this.getTags().join(', '))
      },
      openFile (id) {
        const onNewVersion = () => this.newFile(id)
        depo.openFile(id, this.getDepoCurrentPath, false, onNewVersion)
      },
      addFile () {
        this.newFile(null)
      },
      deleteFolders (ids) {
        this.depoFolders.filter(i => ids.includes(i.uid))
        .forEach(f => dialogs.confirm(this,
            'Подтвердите',
            `Папка ${f.docName} будет удалена и все файлы перемещены в текущую папку. Удалить папку?`,
            (self) => {
              self.$store.dispatch('deleteDepoFolder', f)
              self.cxt && self.cxt.toViewMode()
            })
          )
      },
      copyProps (ids) {
        const printProps = f => {
          return `Документ: ${f.docName}${f.signed ? '\n\t' + this.renderDepoFileSignMessage(f) : ''}\n\tCсылка: ${this.getDepoUrl(f.uid)} \n\tДепонировано: ${formats.formatDateTime(f.uploaded)} (по: ${formats.formatDate(f.deleted)})\n\tДепонент: ${f.ownerShortName} ИНН: ${formats.formatInn(f.ownerInn)}\n`
        }
        var text = this.items.filter(i => ids.includes(i.uid)).map(i => {
          return printProps(i)
        }).join('\n')
        this.$store.dispatch('copyToClipboard', {text: text})
        this.cxt && this.cxt.toViewMode()
      },
      sendProps (ids) {
        depo.sendProps(ids)
        this.cxt && this.cxt.toViewMode()
      },
      copyLinks (ids) {
        var html = this.items.filter(i => ids.includes(i.uid)).map(i => {
          return `<a href="${this.getDepoUrl(i.uid)}">${i.docName}</a>`
        }).join(' ')
        // var text = this.items.filter(i => ids.includes(i.uid)).map(i => {
        //   return `${i.docName}: ${this.getDepoUrl(i.uid)}`
        // }).join('\n')
        this.$store.dispatch('copyToClipboard', {text: html, html: html})
        this.cxt && this.cxt.toViewMode()
      },
      updateFolder (ids) {
        const setPath = (path) => {
          if (Array.isArray(ids)) {
            dialogs.confirm(this,
            'Подтвердите',
            'Переместить файлы?',
            (self) => {
              self.$store.dispatch('updateDepoFilePaths', {uids: ids, path: path})
              self.cxt && self.cxt.toViewMode()
            })
          }
        }
        dialogs.register('v-folder-selector', vFolderSelector)
        var path = this.getDepoCurrentPath
        var fullscreen = false
        var comp = { template: `
          <v-folder-selector v-on:close="$emit('close')"
          v-on:input="setItem"
          :path="path"
          :fullscreen="fullscreen"></v-folder-selector>
          `,
          data () {
            return {
              fullscreen: fullscreen,
              setItem: setPath,
              path: path
            }
          }
        }
        dialogs.modal(comp)
      },
      openFolder (id) {
        dialogs.register('v-doc-folder', vDocFolder)
        var path = this.getDepoCurrentPath
        var comp = { template: `
          <v-doc-folder toolbar :fileItemId="dialogItemId" :newPath="path" v-on:close="$emit('close')"></v-doc-folder>
          `,
          data () {
            return {
              dialogItemId: id,
              path: path
            }
          }
        }
        dialogs.modal(comp)
      },
      addFolder () {
        this.openFolder(null)
      },
      open (item) {
        let url = this.getDepoUrl(item.uid) + '/stream'
        this.$store.dispatch('openLocation', url)
      },
      downloadFiles (ids) {
        var link = this.getDepoFilesUrl(ids)
        depo.downloadFile(link)
        this.cxt && this.cxt.toViewMode()
      },
      createPreview (item) {
        return depo.createPreview(item, this)
      },
      onInnChanged (refs) {
        let tags = refs.map(ref => `#${ref}`)
        this.setTags(tags)
      },
      fillRefChips (refs) {
        const getHint = company => {
          return `${company.name} (ИНН: ${formats.formatInn(company.inn)})`
        }
        const getError = company => null
        const cb = (companies) => {
          let set = new Set(refs)
          let items = companies.map(c => {
            set.delete(c.ref)
            return {value: c.ref, text: c.caption, hint: getHint(c), error: getError(c)}
          })
          set.forEach(ref => items.push({value: ref + '', text: '#' + ref, hint: 'Чтобы видеть название компании, добавьте компанию в Мои Контрагенты', error: null}))
          this.chipsItems = items
        }
        client.getCachedRefs(refs, cb)
      },
      selectInn () {
        const onSelect = (companies) => {
          console.log('onSelect', companies)
          if (Array.isArray(companies)) {
            this.onInnChanged(companies.map(c => c.ref + '' || ''))
          }
        }
        client.selectRef(this, onSelect, () => {}, true, true)
      },
      removeInn (v) {
        this.onInnChanged([])
      },
      getRefs (tags) {
        return tags.map(tag => tag.replace('#', ''))
      },
      getTags () {
        return [].concat(this.$route.query && this.$route.query.tag ? this.$route.query.tag : [])
      },
      setTags (tags) {
        this.$router.push({path: this.$router.path, query: { tag: tags }})
      },
      setFolder (folder) {
        this.$router.push({path: '/doc_list/' + folder, query: { tag: this.getTags() }})
      },
      updateTags (selectedIds) {
        const onTagChange = (inns) => {
          let innTags = inns.map(inn => `#${inn}`)
          dialogs.confirm(this,
            'Подтвердите',
            `Метки [${innTags.join(', ')}] будут добавлены к выбранным документам. Добавить метки?`,
            () => {
              this.$store.dispatch('updateDepoFileTags', {uids: selectedIds, tags: innTags})
              this.cxt && this.cxt.toViewMode()
            })
        }
        const onSelect = (companies) => {
          console.log('onSelect', companies)
          if (Array.isArray(companies)) {
            onTagChange(companies.map(c => c.ref || ''))
          }
        }
        client.selectRef(this, onSelect, () => {}, true, true)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DocList.vue?58c86a90